// internal
import { axios, def, handleError, handleResponse } from './internal';

// state
import { storage } from '@goldblack/client-storage';

function AdminUserChangeSubscription(userId, status, plan, expires_at, onSuccess) {
    axios
        .post('/api/admin_user_changesubscription', {
            userId,
            status,
            plan,
            expires_at,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK: {
                    const { user } = res.data.data;
                    storage.transience.setState('internal.success', 'The subscription has been updated.');
                    if (onSuccess) onSuccess(user);
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserChangeSubscription };
